import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { vendorService } from '@/api/admin/services/vendor.service';
import type { VendorPayload } from '@/types/dashboard/vendor';

export const vendorKeys = { list: ['admin', 'vendors'] as const };

export function useVendors() {
  return useQuery({ queryKey: vendorKeys.list, queryFn: () => vendorService.list() });
}

export function useCreateVendor() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (payload: VendorPayload) => vendorService.create(payload),
    onSuccess: () => qc.invalidateQueries({ queryKey: vendorKeys.list }),
  });
}

export function useUpdateVendor() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, payload }: { id: number; payload: Partial<VendorPayload> }) =>
      vendorService.update(id, payload),
    onSuccess: () => qc.invalidateQueries({ queryKey: vendorKeys.list }),
  });
}

export function useDeleteVendor() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => vendorService.remove(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: vendorKeys.list }),
  });
}